import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'evoRoundedCurrencyPipe' })
export class EvoRoundedCurrencyPipe implements PipeTransform {
	transform(value: number): any | string {
		if (value <= 999999) {
			return '$' + ((value)).toLocaleString('en');
		} else if (value >= 1000000 && value <= 999999999) {
			return '$' + ((value / 1000000)).toFixed(1) + 'M';
		} else if (value >= 1000000000 && value <= 999999999999) {
			return '$' + ((value / 1000000000)).toFixed(1) + 'B';
		} else {
			return value;
		}
	}
}

@Pipe({ name: 'evoRoundedCurrencyPipeNoDecimals' })
export class EvoRoundedCurrencyPipeNoDecimals implements PipeTransform {
	transform(value: number): any | string {
		if (value <= 999999) {
			const multiplier = Math.pow(10, 0);
			value = Math.round(value * multiplier) / multiplier;
			return '$' + ((value)).toLocaleString('en');
		} else if (value >= 1000000 && value <= 999999999) {
			return '$' + ((value / 1000000)).toFixed(0) + 'M';
		} else if (value >= 1000000000 && value <= 999999999999) {
			return '$' + ((value / 1000000000)).toFixed(0) + 'B';
		} else {
			return value;
		}
	}
}

@Pipe({ name: 'evoRoundedCurrencyPipeNoDecimalsThousands' })
export class EvoRoundedCurrencyPipeNoDecimalsThousands implements PipeTransform {
	transform(value: number): any | string {
		if (value <= 999) {
			const multiplier = Math.pow(10, 0);
			value = Math.round(value * multiplier) / multiplier;
			return '$' + (value).toLocaleString('en');
		} else if (value >= 1000) {
			const roundedThousands = '$' + (value / 1000).toLocaleString('en');
			return roundedThousands.slice(0, roundedThousands.indexOf('.')) + 'k' ;
		} else {
			return value;
		}
	}
}

@Pipe({ name: 'evoRoundedPipeNoDecimalsThousands' })
export class EvoRoundedPipeNoDecimalsThousands implements PipeTransform {
	transform(value: number): any | string {
		if (value <= 999) {
			const multiplier = Math.pow(10, 0);
			value = Math.round(value * multiplier) / multiplier;
			return (value).toLocaleString('en');
		} else if (value >= 1000) {
			const roundedThousands = (value / 1000).toLocaleString('en');
			return roundedThousands.slice(0, roundedThousands.indexOf('.')) + 'k' ;
		} else {
			return value;
		}
	}
}
